import Button from "atoms/buttons/button";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import { t } from "i18next";
import React from "react";

const STATUS_CLASS = "c-suggestion-status";

const RejectedToolCallSuggestion = ({ onUndo }) => {
    const dismissedSupportingText = t("casi-checklist-creation-dismiss-text");

    return (
        <>
            <div className={`${STATUS_CLASS} -rejected`}>
                <Icon
                    type={Icons.Close}
                    size={IconSizes.Small}
                    cssClassName={`${STATUS_CLASS}__icon`}
                />
                <span>{dismissedSupportingText}</span>
                <span className={`${STATUS_CLASS}__separator`}>&middot;</span>
                <Button
                    onClick={onUndo}
                    size={ButtonSizes.Small}
                    style={ButtonStyles.Text}>
                    {t("undo")}
                </Button>
            </div>
            <div style={{ height: "4px" }} />
        </>
    );
};
export default RejectedToolCallSuggestion;
